import { Camera, Object3D, PerspectiveCamera } from "three";
import { CameraConfig, CameraOptions } from "../views/views-config";
import { RoulerPromise } from "../animation/rouler";
import { animatePose } from "../animation/animate-pose";
import { easeInOutSine } from '../math/lerp';

const
    TRANSITION_DURATION = 300, // 10 frames at 30fps
    scratch = new Object3D();

let transition: RoulerPromise;

/**
 * Animate the camera to the position/rotation of the saved camera config. If
 * the target is given, then the camera will look at the target instead of
 * using the saved rotation data.
 */
export const applySavedViewCamera =
    (savedCamera: CameraOptions, camera: Camera): Promise<void> =>
{
    if(transition) transition.canceled = true;

    scratch.position.set(
        savedCamera.position.x || 0,
        savedCamera.position.y || 0,
        savedCamera.position.z || 0);

    scratch.rotation.set(
        savedCamera.rotation.x || 0,
        savedCamera.rotation.y || 0,
        savedCamera.rotation.z || 0);

    // Note that animatePose has a global update mechanism used by the main
    // application to ensure that changes are correctly rendered.
    transition = animatePose(
        TRANSITION_DURATION, camera, scratch, easeInOutSine);

    return new Promise(async (resolve) => {
        try {
            await transition;
        } finally {
            resolve();
        }
    });
}

export const extractSavedViewCamera = (camera: PerspectiveCamera): CameraConfig => {
    return {
        position: {
            x: camera.position.x,
            y: camera.position.y,
            z: camera.position.z,
        },
        rotation: {
            x: camera.rotation.x,
            y: camera.rotation.y,
            z: camera.rotation.z,
        },
        verticalFov: camera.fov,
    };
}
